module.exports = __webpack_public_path__ + "img/how_retail.d0719cf2.png";